import * as z from "zod";

import { PartnerUserSummarySchema } from "../shared/partner-user";

export const getMe = {
  name: "getMe" as const,
  input: z.object({}),
  output: z.object({ partnerUser: PartnerUserSummarySchema }),
};
